class MultiCardImage extends HTMLElement {
  constructor() {
    super();

    this.slider = this.querySelector('[data-slider]');
    this.slides = Array.from(this.querySelectorAll('[data-slide]'));
    this.prevButton = this.querySelector('[data-prev-button]');
    this.nextButton = this.querySelector('[data-next-button]');

    if (!this.slider || this.slides.length < 2) {
      if(this.prevButton) this.prevButton.style.display = 'none';
      if(this.nextButton) this.nextButton.style.display = 'none';
      return;
    }

    this.slideWidth = 0;
    this.currentIndex = 0;

    this.init();
  }

  init() {
    // Calculate slide width after images are potentially loaded
    // Use ResizeObserver for better responsiveness
    const resizeObserver = new ResizeObserver(entries => {
      for (let entry of entries) {
        if (entry.target === this.slider && this.slides.length > 0) {
           // Use scrollWidth of the container as the slide width
           this.slideWidth = this.slider.scrollWidth / this.slides.length;
           this.updateButtonStates();
           this.scrollToCurrentIndex(); // Adjust scroll position on resize
        }
      }
    });

    resizeObserver.observe(this.slider);

    // Initial calculation attempt (might be zero if images not loaded)
    if(this.slides.length > 0) {
      this.slideWidth = this.slider.scrollWidth / this.slides.length;
    }

    this.prevButton.addEventListener('click', this.prevSlide.bind(this));
    this.nextButton.addEventListener('click', this.nextSlide.bind(this));

    // Use scroll event listener to update index and buttons after manual scroll/swipe
    this.slider.addEventListener('scroll', this.debounce(this.handleScroll.bind(this), 50));

    this.updateButtonStates();
  }

  handleScroll() {
    if (this.slideWidth > 0) {
        const newIndex = Math.round(this.slider.scrollLeft / this.slideWidth);
        if (newIndex !== this.currentIndex) {
            this.currentIndex = newIndex;
            this.updateButtonStates();
        }
    }
  }

  prevSlide() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.scrollToCurrentIndex();
    }
  }

  nextSlide() {
    if (this.currentIndex < this.slides.length - 1) {
      this.currentIndex++;
      this.scrollToCurrentIndex();
    }
  }

  scrollToCurrentIndex() {
    if (this.slideWidth > 0) {
      const scrollAmount = this.currentIndex * this.slideWidth;
      this.slider.scrollTo({
        left: scrollAmount,
        behavior: 'smooth'
      });
    } else {
      // Fallback or error handling if slideWidth is still 0
      console.warn('Slide width not calculated, cannot scroll.');
    }
    // Update buttons immediately after initiating scroll
    this.updateButtonStates();
  }

  updateButtonStates() {
    if (!this.prevButton || !this.nextButton) return;
    
    // Handle floating point inaccuracies for scrollLeft
    const scrollStartReached = this.slider.scrollLeft < 1;
    // Check if scroll end is reached (within a small tolerance)
    const scrollEndReached = Math.abs(this.slider.scrollWidth - this.slider.clientWidth - this.slider.scrollLeft) < 1;

    this.prevButton.disabled = this.currentIndex === 0 || scrollStartReached;
    this.nextButton.disabled = this.currentIndex === this.slides.length - 1 || scrollEndReached;
  }

  // Debounce utility
  debounce(func, wait) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }
}

customElements.define('multi-card-image', MultiCardImage); 